{
  "name": "@kulturit/m24-admin",
  "version": "2.9.8",
  "private": true,
  "type": "module",
  "scripts": {
    "start": "vite",
    "build": "tsc && vite build",
    "build:ci": "vite build",
    "preview": "vite preview",
    "test": "vitest -w",
    "test:ui": "vitest --ui --open false",
    "test:once": "vitest run --coverage",
    "test:ci": "vitest run --silent --passWithNoTests",
    "test:ci:coverage": "vitest run --coverage --silent --passWithNoTests --reporter junit --outputFile ./coverage/junit.xml",
    "lint": "eslint \"**/*.{js,jsx,ts,tsx}\" && tsc --noEmit",
    "lint:fix": "eslint \"**/*.{js,jsx,ts,tsx}\" --fix && tsc --noEmit",
    "prepare": "husky install",
    "check-missing-translations": "node ./scripts/checkLanguageKeys.cjs",
    "postinstall": "node ./scripts/postinstall.cjs"
  },
  "dependencies": {
    "@babel/core": "^7.20.12",
    "@ekultur/authentication": "^6.0.2",
    "@ekultur/dms-upload": "^2.0.10",
    "@ekultur/fetch": "^5.0.2",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@fontsource/roboto": "^4.5.3",
    "@googlemaps/js-api-loader": "^1.16.1",
    "@mui/base": "^5.0.0-beta.70",
    "@mui/icons-material": "^9.0.0",
    "@mui/material": "^9.0.0",
    "@mui/system": "^9.0.0",
    "@mui/utils": "^9.0.0",
    "@mui/x-date-pickers": "^9.0.2",
    "@mui/x-tree-view": "^9.0.2",
    "@sentry/react": "^8.2.1",
    "@sentry/vite-plugin": "^2.16.1",
    "@tinymce/tinymce-react": "4.3.2",
    "@types/autosuggest-highlight": "^3.2.0",
    "@types/google.maps": "^3.53.3",
    "@types/googlemaps": "^3.43.3",
    "autosuggest-highlight": "^3.3.4",
    "dayjs": "^1.11.9",
    "fs-extra": "^11.3.4",
    "i18next": "^21.8.4",
    "i18next-browser-languagedetector": "^6.1.3",
    "i18next-http-backend": "^1.3.2",
    "i18next-intervalplural-postprocessor": "^3.0.0",
    "notistack": "^3.0.1",
    "prop-types": "^15.8.1",
    "react": "^19.2.5",
    "react-dnd": "16.0.1",
    "react-dnd-html5-backend": "16.0.1",
    "react-dom": "^19.2.5",
    "react-frame-component": "^5.2.3",
    "react-hook-form": "^7.74.0",
    "react-i18next": "^12.1.5",
    "react-router-dom": "^6.8.1",
    "rxjs": "^7.8.0",
    "tinymce": "6.8.3"
  },
  "devDependencies": {
    "@babel/plugin-syntax-flow": "^7.17.12",
    "@babel/plugin-transform-react-jsx": "^7.17.12",
    "@svgr/plugin-svgo": "8.1.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/express": "^4.17.13",
    "@types/node": "^24",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@typescript-eslint/eslint-plugin": "^8.59.0",
    "@typescript-eslint/parser": "^8.59.0",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.1.5",
    "@vitest/ui": "^4.1.5",
    "autoprefixer": "^10.4.13",
    "c8": "^7.12.0",
    "cross-fetch": "^3.1.5",
    "eslint": "^8.34.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.25.4",
    "eslint-plugin-jsx-a11y": "^6.5.1",
    "eslint-plugin-prettier": "^4.0.0",
    "eslint-plugin-react": "^7.32.2",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-testing-library": "^7.16.2",
    "husky": "^8.0.1",
    "jsdom": "^29.1.0",
    "lint-staged": "^12.4.1",
    "msw": "^1.0.1",
    "prettier": "^2.5.1",
    "react-dnd-test-backend": "^16.0.1",
    "translation-check": "^1.0.2",
    "typescript": "^6.0.3",
    "vite": "^8.0.10",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.5"
  },
  "resolutions": {
    "**/@types/react": "19.2.14",
    "**/@types/react-dom": "19.2.3"
  },
  "engines": {
    "node": ">=24.22.1"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  }
}
